module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9AO0s"))).then(() => parcelRequire('8rm4T'));